import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({providedIn:'root'})
export class ComposicaoAtoService {
 constructor(private http: HttpClient) {}
 private url = `${environment.URL_API}/composicao-ato`;
 buscar(matricula: string, idOrgao: number) { return this.http.get<any>(this.url,{params:{matricula,idOrgao}}); }
 salvar(payload:any) { return this.http.put<any>(this.url,payload); }
 quadro(matricula:string,idOrgao:number) { return this.http.get(`${this.url}/quadro`,{params:{matricula,idOrgao},responseType:'blob'}); }
}
